export const FeedbackAPI = {
  addFeedback: (orderId: string) => `/order/${orderId}/feedback`
};
